import { AKUSTIKK_INIT_DATA } from "./reportInitdata/akustikkPremissrapportData";
import { BRANNKONSEPT_INIT_DATA } from "./reportInitdata/brannkonseptData";
import { BYGNINGSFYSIKK_INIT_DATA } from "./reportInitdata/bygningsfysikkPremissrapportData";
import { Eksempel_RAPPORT_INIT_DATA } from "./reportInitdata/eksempelRapportData";
import { ELEKTRO_SAMSVARSERKLARING_EKOMNETT_INIT_DATA } from "./reportInitdata/elektroSamsvarserklaringEkomnettData";
import { ELEKTRO_SAMSVARSERKLARING_FEL_INIT_DATA } from "./reportInitdata/elektroSamsvarserklaringFELData";
import {
  GEOTEKNIKRAPPORT_INIT_DATA,
  GEOTEKNIKRAPPORT_OMRAADESTABILITET_INIT_DATA,
} from "./reportInitdata/geoteknikRapportData";
import { GKRAPPORT_INIT_DATA } from "./reportInitdata/gkRapportData";
import { INTERN_JURIDISK_UNDERKONSULENT_INIT_DATA } from "./reportInitdata/internjuridiskData";
import { OVERLEVERING_CHECKLIST_INIT_DATA } from "./reportInitdata/startupChecklistData";
import { ZAkustikkPremissRapportSchema } from "./reportSchemas/akustikk/akustikkPremissrapportSchema";
import { ZBygningsfysikkPremissRapportSchema } from "./reportSchemas/bygningsfysikk/bygningsfysikkPremissrapport/bygningsfysikkPremissrapportSchema";
import { ZEksempelrapportSchema } from "./reportSchemas/eksempelRapportSchema";
import { ZElektroSamsvarserklaringEkomnettSchema } from "./reportSchemas/elektroSamsvarserklaringEkomnettSchema";
import { ZElektroSamsvarserklaringFELSchema } from "./reportSchemas/elektroSamsvarserklaringFELSchema";
import { ZGeoTeknikkRapportSchema } from "./reportSchemas/geoteknikSchema";
import { GKRapportSchema } from "./reportSchemas/gkReportSchema";
import { ZInternJuridiskUnderkonsulentRapportSchema } from "./reportSchemas/internJuridiskSchema";
import { IReportTemplate } from "./reportSchemas/reportSchemas";
import { ZSJArapportSchema } from "./reportSchemas/sjaSchema";
import { ZOverleveringChecklistReport } from "./reportSchemas/startupChecklistSchema";
import { SJA_INIT_DATA } from "./SJAData";

const USER_IDS = {
  ERVIK: {
    _id: "5d13126416bae53ac5a0a8d5",
    name: "Vegard Ervik Olsen",
  },
  JASPER: {
    _id: "600e88cdf4c70d3fc19ff95a",
    name: "Jesper Bjerre",
  },
  ANDERS: {
    _id: "61fa2d9c553da241919ec4c6",
    name: "Anders Nilssen",
  },
  ANETTE: {
    _id: "68554d0e0fc69a46a516d799",
    name: "Anette Øvreeide",
  },
  MARTIN: {
    _id: "61fa2db0553da241919ec6ba",
    name: "Martin Magraff",
  },
  PER: {
    _id: "5c88d20edbb10a37c75aa7ae",
    name: "Per Ström",
  },
  INGVILD: {
    _id: "675fea73e901572f889765a9",
    name: "Ingvild Mysen",
  },
  KAMILLA: {
    _id: "689f0fd0cabc1fa05c16baf5",
    name: "Kamilla Moen",
  },
  DANIEL: {
    _id: "66fc1a53f8d30b6ec21322ac",
    name: "Daniel Jettli",
  },
  SOLVOR: {
    _id: "68b7e445a61abd2d62ef5d91",
    name: "Solvor Sevland",
  },
};

export enum domainAccessEnum {
  MULTICONSULT = "MULTICONSULT.NO",
  GK = "GK.NO",
}

export const REPORT_TEMPLATES: IReportTemplate[] = [
  {
    enabledForUser: true,
    templateId: 101,
    name: "Eksempel",
    description: "En enkel rapportmal som viser grunnleggende funksjonalitet.",
    admin: USER_IDS.MARTIN,
    domainsWithAccess: [domainAccessEnum.MULTICONSULT],
    data: Eksempel_RAPPORT_INIT_DATA,
    zodSchema: ZEksempelrapportSchema,
  },
  {
    enabledForUser: true,
    templateId: 102,
    name: "Brannkonsept",
    description: "Malen benyttes til utarbeidelse av brannkonsept for byggverk i henhold til TEK17.",
    admin: USER_IDS.ERVIK,
    domainsWithAccess: [domainAccessEnum.MULTICONSULT],
    data: BRANNKONSEPT_INIT_DATA,
  },
  {
    enabledForUser: true,
    templateId: 103,
    name: "RIG - Datarapport",
    description: "Malen benyttes til rapportering av geotekniske grunnundersøkelser på land og sjø.",
    admin: USER_IDS.JASPER,
    domainsWithAccess: [domainAccessEnum.MULTICONSULT],
    data: GEOTEKNIKRAPPORT_INIT_DATA,
    zodSchema: ZGeoTeknikkRapportSchema,
  },
  {
    enabledForUser: true,
    templateId: 104,
    name: "GK",
    description: "Rapportmal for validering og kontroll av renrom og luftteknisk utstyr.",
    admin: USER_IDS.ANDERS,
    domainsWithAccess: [domainAccessEnum.GK],
    data: GKRAPPORT_INIT_DATA,
    zodSchema: GKRapportSchema,
  },
  {
    enabledForUser: true,
    templateId: 106,
    name: "RIG - Vurdering av områdestabilitet ihht. NVE 1/2019",
    description: "Malen benyttes til rapportering av områdestabilitet ihht. NVE 1/2019.",
    admin: USER_IDS.JASPER,
    domainsWithAccess: [domainAccessEnum.MULTICONSULT],
    data: GEOTEKNIKRAPPORT_OMRAADESTABILITET_INIT_DATA,
    zodSchema: ZGeoTeknikkRapportSchema,
  },
  {
    enabledForUser: true,
    templateId: 201,
    name: "Elektro - Samsvarserklaring FEL",
    description: "",
    admin: USER_IDS.KAMILLA,
    domainsWithAccess: [domainAccessEnum.MULTICONSULT],
    data: ELEKTRO_SAMSVARSERKLARING_FEL_INIT_DATA,
    zodSchema: ZElektroSamsvarserklaringFELSchema,
  },
  {
    enabledForUser: true,
    templateId: 202,
    name: "Elektro - Samsvarserklaring EKOMNETT",
    description: "",
    admin: USER_IDS.KAMILLA,
    domainsWithAccess: [domainAccessEnum.MULTICONSULT],
    data: ELEKTRO_SAMSVARSERKLARING_EKOMNETT_INIT_DATA,
    zodSchema: ZElektroSamsvarserklaringEkomnettSchema,
  },
  {
    enabledForUser: true,
    templateId: 205,
    name: "Elektro - SJA",
    description: "Rapportmal for valg av punkter til SJA",
    admin: USER_IDS.ANETTE,
    domainsWithAccess: [domainAccessEnum.MULTICONSULT],
    data: SJA_INIT_DATA,
    zodSchema: ZSJArapportSchema,
  },
  {
    enabledForUser: true,
    templateId: 301,
    name: "Bygningsfysikk - Premissrapport",
    description: "Rapportmal for premissrapport bygningsfysikk",
    admin: USER_IDS.DANIEL,
    domainsWithAccess: [domainAccessEnum.MULTICONSULT],
    data: BYGNINGSFYSIKK_INIT_DATA,
    zodSchema: ZBygningsfysikkPremissRapportSchema,
  },
  {
    enabledForUser: true,
    templateId: 401,
    name: "Akustikk - Premissrapport",
    description: "Rapportmal for premissrapport akustikk",
    admin: USER_IDS.SOLVOR,
    domainsWithAccess: [domainAccessEnum.MULTICONSULT],
    data: AKUSTIKK_INIT_DATA,
    zodSchema: ZAkustikkPremissRapportSchema,
  },
  {
    enabledForUser: true,
    templateId: 701,
    name: "Underkonsulentavtale - Selvstendig",
    description: "Rapportmal for utfylling av underkonsulentavtale for selvstendig næringsdrivende.",
    admin: USER_IDS.MARTIN,
    domainsWithAccess: [domainAccessEnum.MULTICONSULT],
    data: INTERN_JURIDISK_UNDERKONSULENT_INIT_DATA,
    zodSchema: ZInternJuridiskUnderkonsulentRapportSchema,
  },
  {
    enabledForUser: true,
    templateId: 901,
    name: "Sjekkliste for overlevering av oppdrag fra TA og TL til OA og OL",
    description: "Demorapport for startup-sjekkliste.",
    admin: USER_IDS.MARTIN,
    domainsWithAccess: [domainAccessEnum.MULTICONSULT],
    data: OVERLEVERING_CHECKLIST_INIT_DATA,
    zodSchema: ZOverleveringChecklistReport,
  },
];
